import React, { useState } from 'react';
import './ShareModal.css';

export const ShareModal = ({ isOpen, onClose, url, title }) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  const shareUrl = url || window.location.href;
  const shareTitle = title || 'Check this out!';

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const socialLinks = [
    {
      name: 'Instagram',
      icon: 'fab fa-instagram',
      color: '#E4405F',
      bgGradient: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)',
      url: `https://www.instagram.com/`
    },
    {
      name: 'Twitter',
      icon: 'fab fa-twitter',
      color: '#1DA1F2',
      url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`
    },
    {
      name: 'LinkedIn',
      icon: 'fab fa-linkedin-in',
      color: '#0A66C2',
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`
    },
    {
      name: 'WhatsApp',
      icon: 'fab fa-whatsapp',
      color: '#25D366',
      url: `https://wa.me/?text=${encodeURIComponent(shareTitle + ' ' + shareUrl)}`
    },
    {
      name: 'Facebook',
      icon: 'fab fa-facebook-f',
      color: '#1877F2',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`
    }
  ];

  return (
    <div className="share-modal-overlay" onClick={onClose}>
      <div className="share-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="share-modal-close" onClick={onClose}>
          ×
        </button>

        <h2 className="share-modal-title">Share Event</h2>

        <div className="share-social-icons">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="share-social-btn"
              style={{ 
                background: social.bgGradient || social.color,
                '--hover-color': social.color 
              }}
              title={social.name}
            >
              <i className={social.icon}></i>
            </a>
          ))}
        </div>

        <div className="share-copy-section">
          <p className="share-copy-label">Or copy link</p>
          <div className="share-copy-input-wrapper">
            <input 
              type="text" 
              value={shareUrl} 
              readOnly 
              className="share-copy-input"
            />
            <button 
              className={`share-copy-btn ${copied ? 'copied' : ''}`}
              onClick={handleCopy}
            >
              {copied ? (
                <i className="fas fa-check"></i>
              ) : (
                <i className="far fa-copy"></i>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
